// src/utils/reporteRecepcionEquipoGenerator.js

import { obtenerDatosEmpresa } from './tenantConfig';
import html2pdf from 'html2pdf.js';

const JEAN_INFORMATICO_CONFIG = {
  nombre: "JEAN INFORMATICO C.A.",
  rif: "J-41023119-0",
  direccion: "Calle 30 con Av. 33, C.C. Latin Center P/B, Local 01 - Acarigua, Portuguesa",
  telefono: "0412-5696219 / 0416-7594723",
  whatsapp: "04167594723",
  ciudad: "Acarigua, Estado Portuguesa",
  email: "soportejeaninformatico@gmail.com",
  sitioWeb: "www.jeaninformatico.com.ve",
  slogan: "",
  lema: ""
};

const NOMBRES_PLACEHOLDER = [
  'MI EMPRESA', 'EMPRESA', 'MI NEGOCIO', 'NEGOCIO',
  'MI COMPAÑIA', 'MI COMPAÑÍA', 'COMPAÑIA', 'COMPAÑÍA',
  'MI TIENDA', 'TIENDA', 'SIN NOMBRE', 'S/N', ''
];

const esNombreValido = (nombre) => {
  if (!nombre) return false;
  const n = String(nombre).trim().toUpperCase();
  if (!n) return false;
  return !NOMBRES_PLACEHOLDER.includes(n);
};

const getEmpresa = () => {
  try {
    const datos = obtenerDatosEmpresa() || {};
    const nombreTenant = datos.nombreComercial || datos.nombre || '';
    const nombreFinal = esNombreValido(nombreTenant)
      ? nombreTenant
      : JEAN_INFORMATICO_CONFIG.nombre;

    return {
      nombre: nombreFinal,
      rif: datos.rif || JEAN_INFORMATICO_CONFIG.rif,
      direccion: datos.direccion || JEAN_INFORMATICO_CONFIG.direccion,
      telefono: datos.telefono1 || datos.telefono2 || JEAN_INFORMATICO_CONFIG.telefono,
      whatsapp: datos.whatsapp || datos.telefono1 || JEAN_INFORMATICO_CONFIG.whatsapp,
      ciudad: datos.ciudad || JEAN_INFORMATICO_CONFIG.ciudad,
      email: datos.email || JEAN_INFORMATICO_CONFIG.email,
      sitioWeb: datos.sitioWeb || JEAN_INFORMATICO_CONFIG.sitioWeb,
      slogan: datos.slogan || '',
      lema: datos.slogan || '',
      logoBase64: datos.logoBase64 || null,
    };
  } catch (err) {
    return { ...JEAN_INFORMATICO_CONFIG, logoBase64: null };
  }
};

// ==================== LOGO ====================
let LOGO_BASE64 = '';
let LOGO_MIME = 'image/jpeg';

const detectarMimeDesdeBase64 = (b64) => {
  if (!b64) return 'image/jpeg';
  if (b64.startsWith('/9j/')) return 'image/jpeg';
  if (b64.startsWith('iVBORw0KGgo')) return 'image/png';
  if (b64.startsWith('R0lGOD')) return 'image/gif';
  if (b64.startsWith('UklGR')) return 'image/webp';
  return 'image/jpeg';
};

const limpiarBase64 = (raw) => {
  if (!raw) return '';
  if (raw.includes(',')) return raw.split(',')[1];
  return raw;
};

export const cargarLogo = async () => {
  try {
    const empresa = getEmpresa();

    if (empresa.logoBase64) {
      const limpio = limpiarBase64(empresa.logoBase64);
      if (limpio && limpio.length > 50) {
        LOGO_BASE64 = limpio;
        LOGO_MIME = detectarMimeDesdeBase64(limpio);
        return LOGO_BASE64;
      }
    }

    const response = await fetch('/logo-jean.jpg');
    if (!response.ok) { LOGO_BASE64 = ''; return ''; }
    const blob = await response.blob();
    LOGO_MIME = blob.type || 'image/jpeg';

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        LOGO_BASE64 = limpiarBase64(reader.result);
        resolve(LOGO_BASE64);
      };
      reader.onerror = () => { LOGO_BASE64 = ''; resolve(''); };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    LOGO_BASE64 = '';
    return '';
  }
};

export const getLogoBase64 = () => LOGO_BASE64;
export const getLogoMime = () => LOGO_MIME;
export const getLogoSrc = () => LOGO_BASE64 ? `data:${LOGO_MIME};base64,${LOGO_BASE64}` : '';

// ==================== UTILIDADES ====================

export const formatearFechaReporte = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  } catch { return fechaISO; }
};

export const formatearFechaCorta = (fechaISO) => {
  if (!fechaISO) return 'No disponible';
  try {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-VE', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });
  } catch { return fechaISO; }
};

export const formatearNumero = (numero, decimales = 2) => {
  if (numero === null || numero === undefined) return '0.00';
  return new Intl.NumberFormat('es-VE', {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales
  }).format(numero);
};

export const formatearMonedaUSD = (monto) => {
  if (monto === null || monto === undefined) return '$0.00';
  return `$${formatearNumero(monto, 2)}`;
};

// ==================== NORMALIZACIÓN ====================

export const normalizarRecepcion = (item) => {
  if (!item) return null;
  return {
    idRecepcionEquipo: item.idRecepcionEquipo,
    numeroOrden: item.numeroOrden || `ORD-${item.idRecepcionEquipo || '000'}`,
    fechaIngreso: item.fechaIngreso,
    fechaEntrega: item.fechaEntrega,
    fechaPago: item.fechaPago,
    nombreCliente: item.nombreCliente || 'Cliente Desconocido',
    idCliente: item.idCliente,
    descripcion: item.descripcion || 'Sin descripción',
    nombreTecnicoRecepcion: item.nombreTecnicoRecepcion || item.nombreUsuario || '---',
    nombreEstado: item.nombreEstado || 'RECIBIDO',
    precioTotalUsd: item.precioTotalUsd || 0,
    tipoDiagnostico: item.tipoDiagnostico || item.TipoDiagnostico || '',
    montoPagadoDiagnosticoUsd: item.montoPagadoDiagnosticoUsd || 0
  };
};

export const normalizarRecepciones = (items) => {
  if (!Array.isArray(items)) return [];
  return items.map(item => normalizarRecepcion(item));
};

export const getEstadoStyle = (estado) => {
  const e = estado?.toLowerCase() || '';
  if (e.includes('diagno')) return 'background: #fef3c7; color: #92400e;';
  if (e.includes('reparado')) return 'background: #dcfce7; color: #166534;';
  if (e.includes('entrega')) return 'background: #dbeafe; color: #1e40af;';
  if (e.includes('espera')) return 'background: #f3e8ff; color: #6b21a8;';
  return 'background: #f3f4f6; color: #374151;';
};

// ==================== DIAGNÓSTICO ====================

export const getDiagnosticoTexto = (item) => {
  const tipo = ((item?.tipoDiagnostico || '') + '').toUpperCase();
  const montoDiag = Number(item?.montoPagadoDiagnosticoUsd) || 0;
  if (tipo.includes('EXPRE') || montoDiag > 0) return 'EXPRESS';
  return 'GRATIS';
};

export const getDiagnosticoStyle = (texto) => {
  return texto === 'EXPRESS'
    ? 'background: #ffe4e6; color: #9f1239;'
    : 'background: #d1fae5; color: #065f46;';
};

export const COSTO_DIAGNOSTICO_EXPRESS = 10;

export const getTotalConDiagnostico = (item) => {
  const base = Number(item?.precioTotalUsd) || 0;
  const esExpress = getDiagnosticoTexto(item) === 'EXPRESS';
  return esExpress ? base + COSTO_DIAGNOSTICO_EXPRESS : base;
};

// ==================== ESTADÍSTICAS ====================

export const calcularEstadisticasRecepcion = (recepciones) => {
  const items = normalizarRecepciones(recepciones);
  const total = items.length;
  const reparados = items.filter(r => r.nombreEstado?.toLowerCase().includes('reparado')).length;
  const entregados = items.filter(r => r.nombreEstado?.toLowerCase().includes('entrega')).length;
  const pendientes = total - entregados;
  const totalGeneral = items.reduce((acc, r) => acc + getTotalConDiagnostico(r), 0);
  return { total, reparados, entregados, pendientes, totalGeneral };
};

// ==================== HTML IMPRIMIBLE ====================

export const generarHTMLReporteRecepcion = (recepciones, titulo = 'REPORTE DE REPARACIÓN DE EQUIPOS') => {
  const empresa = getEmpresa();
  const items = normalizarRecepciones(recepciones);
  const fechaActual = new Date();
  const stats = calcularEstadisticasRecepcion(items);
  const logoSrc = getLogoSrc();

  const tituloLimpio = titulo.split(' - ')[0] || 'REPORTE DE REPARACIÓN DE EQUIPOS';

  return `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>${tituloLimpio} - ${empresa.nombre}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: 'Arial', 'Helvetica', sans-serif; background: white; padding: 0; }
    
    .reporte { max-width: 780px; margin: 0 auto; padding: 2px 10px; }

    /* ENCABEZADO: Flexbox alineado al tope */
    .header {
      display: flex;
      align-items: flex-start; 
      justify-content: space-between;
      border-bottom: 2px solid #333;
      padding-bottom: 5px;
      margin-bottom: 8px;
    }
    
    .logo-container {
      flex-shrink: 0;
      width: 110px; 
      display: flex;
      justify-content: center;
      padding-top: 4px; 
    }
    .logo-img { 
      max-height: 55px; 
      max-width: 100px; 
      object-fit: contain; 
    }
    
    .header-center {
      flex: 1;
      text-align: center;
      padding: 0 5px;
    }
    .empresa-nombre { 
      font-size: 14px; 
      font-weight: bold; 
      color: #222; 
      margin-bottom: 1px; 
    }
    .empresa-rif { 
      font-size: 8.5px; 
      color: #222; 
      font-weight: bold; 
      margin-bottom: 1px; 
    }
    .empresa-contactos { 
      font-size: 8px; 
      color: #222; 
      line-height: 1.15; 
      font-weight: bold; 
    }
    /* ⭐ AQUÍ ESTÁ EL CAMBIO DE LA DIRECCIÓN */
    .empresa-direccion {
      font-size: 8.5px; 
      color: #222; /* Color oscuro para que se lea perfecto */
      line-height: 1.2; 
      margin-top: 4px; /* Separación de los correos */
      font-weight: bold;
    }

    /* TÍTULO Y FECHA */
    .titulo { text-align: center; margin-bottom: 5px; }
    .titulo h1 { font-size: 11.5px; font-weight: bold; color: #1a4d8c; text-transform: uppercase; margin-bottom: 1px; }
    .fecha { font-size: 7.5px; color: #666; }

    /* TABLA */
    table {
      width: 100%; border-collapse: collapse; font-size: 8px;
      border: 1px solid #ddd; table-layout: fixed;
    }
    th {
      background: #f0f0f0; padding: 3px 2px; text-align: left;
      font-weight: bold; border-bottom: 1px solid #ccc;
      color: #333; text-transform: uppercase; font-size: 7px;
    }
    td { padding: 2px 2px; border-bottom: 1px solid #eee; vertical-align: top; word-wrap: break-word; }
    tr { page-break-inside: avoid; }
    
    .text-right { text-align: right; }
    .text-center { text-align: center; }
    .font-bold { font-weight: bold; }

    .badge {
      display: inline-block; padding: 1px 2px; border-radius: 2px;
      font-size: 6px; font-weight: bold; text-transform: uppercase;
    }

    /* TOTAL GENERAL */
    .total-section {
      margin-top: 6px;
      display: flex;
      justify-content: flex-end;
      page-break-inside: avoid;
    }
    .total-box {
      border-top: 1.5px solid #333;
      border-bottom: 1.5px solid #333;
      padding: 3px 6px;
      display: flex;
      gap: 10px;
      align-items: center;
      background: #f8f9fa;
    }
    .total-label { font-size: 8px; font-weight: bold; color: #333; }
    .total-amount { font-size: 10px; font-weight: bold; color: #111; }

    .footer {
      margin-top: 8px; font-size: 7px; text-align: center;
      color: #666; padding-top: 3px; border-top: 1px solid #eee;
    }

    @media print {
      @page { margin: 0.5cm; size: portrait; }
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  </style>
</head>
<body>
  <div class="reporte" id="reporte-pdf">
    
    <!-- ENCABEZADO DOBLE LOGO SIMÉTRICO -->
    <div class="header">
      <div class="logo-container">
        ${logoSrc ? `<img src="${logoSrc}" class="logo-img" alt="Logo Izq">` : ''}
      </div>
      
      <div class="header-center">
        <div class="empresa-nombre">${empresa.nombre}</div>
        <div class="empresa-rif">RIF: ${empresa.rif}</div>
        <div class="empresa-contactos">
          0412-5696219 / 0416-7594723<br>
          soportejeaninformatico@gmail.com | jeaninformaticoca@gmail.com
        </div>
        <div class="empresa-direccion">
          Calle 30 con Av. 33, C.C. Latin Center P/B, Local 01 - Acarigua, Portuguesa
        </div>
      </div>
      
      <div class="logo-container">
        ${logoSrc ? `<img src="${logoSrc}" class="logo-img" alt="Logo Der">` : ''}
      </div>
    </div>

    <div class="titulo">
      <h1>${tituloLimpio}</h1>
      <div class="fecha">Generado el: ${formatearFechaReporte(fechaActual.toISOString())}</div>
    </div>

    ${items.length > 0 ? `
    <table>
      <colgroup>
        <col style="width: 9%;">
        <col style="width: 12%;">
        <col style="width: 22%;">
        <col style="width: 25%;">
        <col style="width: 11%;">
        <col style="width: 10%;">
        <col style="width: 8%;">
        <col style="width: 9%;">
      </colgroup>
      <thead>
        <tr>
          <th>Orden</th>
          <th>Fecha</th>
          <th>Cliente</th>
          <th>Equipo</th>
          <th>Recibido</th>
          <th class="text-center">Estado</th>
          <th class="text-center">Diag.</th>
          <th class="text-right">Total $</th>
        </tr>
      </thead>
      <tbody>
        ${items.map(item => {
          const diagTexto = getDiagnosticoTexto(item);
          const diagStyle = getDiagnosticoStyle(diagTexto);
          const totalMostrar = getTotalConDiagnostico(item);
          return `
          <tr>
            <td><strong>#${item.numeroOrden}</strong></td>
            <td>
              <div style="color: #4f46e5;">${formatearFechaCorta(item.fechaPago || item.fechaEntrega || item.fechaIngreso)}</div>
            </td>
            <td>${item.nombreCliente}</td>
            <td>${item.descripcion}</td>
            <td>${item.nombreTecnicoRecepcion || '---'}</td>
            <td class="text-center">
              <span class="badge" style="${getEstadoStyle(item.nombreEstado)}">${item.nombreEstado}</span>
            </td>
            <td class="text-center">
              <span class="badge" style="${diagStyle}">${diagTexto}</span>
            </td>
            <td class="text-right font-bold">${formatearMonedaUSD(totalMostrar)}</td>
          </tr>
          `;
        }).join('')}
      </tbody>
    </table>

    <div class="total-section">
      <div class="total-box">
        <span class="total-label">TOTAL GENERAL:</span>
        <span class="total-amount">${formatearMonedaUSD(stats.totalGeneral)}</span>
      </div>
    </div>

    ` : '<div style="padding: 20px; text-align: center; border: 1px solid #ddd;">No hay registros para mostrar</div>'}

    <div class="footer">
      ${empresa.nombre} • RIF: ${empresa.rif} • Sistema de Gestión de Taller
    </div>
  </div>
</body>
</html>`;
};

// ==================== DESCARGAR PDF (DIRECTO) ====================

export const descargarPDFRecepcion = async (recepciones, titulo = null) => {
  if (!recepciones || recepciones.length === 0) {
    alert('No hay registros para mostrar');
    return false;
  }
  try {
    LOGO_BASE64 = '';
    LOGO_MIME = 'image/jpeg';
    await cargarLogo();

    const htmlReporte = generarHTMLReporteRecepcion(
      recepciones,
      titulo || 'REPORTE DE REPARACIÓN DE EQUIPOS'
    );

    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.left = '-9999px';
    container.style.top = '0';
    container.style.width = '800px';
    container.style.background = '#fff';
    container.innerHTML = htmlReporte;
    document.body.appendChild(container);

    const elemento = container.querySelector('#reporte-pdf');
    const fecha = new Date().toISOString().split('T')[0];
    const nombreArchivo = `Reporte_Reparaciones_${fecha}.pdf`;

    const opciones = {
      margin: [5, 5, 5, 5],
      filename: nombreArchivo,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff' },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'], avoid: ['tr'] } 
    };

    await html2pdf().set(opciones).from(elemento).save();
    document.body.removeChild(container);
    return true;
  } catch (error) {
    alert('Error al generar el PDF: ' + error.message);
    return false;
  }
};

// ==================== IMPRIMIR ====================

export const imprimirReporteRecepcion = async (recepciones, titulo = null) => {
  if (!recepciones || recepciones.length === 0) return false;
  try {
    await cargarLogo();
    const htmlReporte = generarHTMLReporteRecepcion(recepciones, titulo);
    const ventana = window.open('', '_blank', 'width=900,height=800');
    if (!ventana) return false;
    ventana.document.write(htmlReporte);
    ventana.document.close();
    ventana.focus();
    return true;
  } catch (error) {
    return false;
  }
};

// ==================== EXCEL ====================

export const exportarRecepcionExcel = (recepciones, titulo = 'recepcion_equipos') => {
  try {
    const empresa = getEmpresa();
    const items = normalizarRecepciones(recepciones);
    const stats = calcularEstadisticasRecepcion(items);
    const XLSX = require('xlsx');
    const wb = XLSX.utils.book_new();

    const headerRows = [
      [empresa.nombre], [`RIF: ${empresa.rif}`],
      [`Calle 30 con Av. 33, C.C. Latin Center P/B, Local 01 - Acarigua`],
      [`Tel: 0412-5696219 / 0416-7594723`], [],
      ['REPORTE DE REPARACIÓN DE EQUIPOS'],
      [`Generado: ${formatearFechaReporte(new Date().toISOString())}`], []
    ];

    const dataRows = items.map(item => [
      item.numeroOrden, formatearFechaCorta(item.fechaPago || item.fechaEntrega || item.fechaIngreso),
      item.nombreCliente, item.descripcion, item.nombreTecnicoRecepcion || '',
      item.nombreEstado || '', getDiagnosticoTexto(item), getTotalConDiagnostico(item)
    ]);

    const wsData = [...headerRows, ['Orden', 'Fecha', 'Cliente', 'Equipo', 'Recibido', 'Estado', 'Diag.', 'Total ($)'], ...dataRows, ['', '', '', '', '', '', 'TOTAL:', stats.totalGeneral]];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    
    XLSX.utils.book_append_sheet(wb, ws, 'Reparaciones');
    XLSX.writeFile(wb, `${titulo}_${new Date().toISOString().split('T')[0]}.xlsx`);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export default {
  descargarPDFRecepcion, imprimirReporteRecepcion, exportarRecepcionExcel,
  generarHTMLReporteRecepcion, calcularEstadisticasRecepcion,
  normalizarRecepcion, normalizarRecepciones, cargarLogo, getLogoSrc,
  formatearFechaReporte, formatearFechaCorta, formatearMonedaUSD, getEmpresa
};